module.exports = __webpack_public_path__ + "static/media/temperature.41c48953.svg";